var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-loading-bar",attrs:{"role":"status","aria-live":"polite","aria-label":_vm.$t('loading')}},[_vm._m(0),_c('span',{staticClass:"visually-hidden"},[_vm._v(_vm._s(_vm.$t('loading')))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-loading-progress",attrs:{"aria-hidden":"true"}},[_c('span')])
}]

export { render, staticRenderFns }